<template>
  <div v-if="flat">
    <header class="flat-preview__header">
      <h3 class="flat-preview__number" v-if="flat[flatProperties['id']]">
        {{ flat[flatProperties['id']].toUpperCase() }}
      </h3>
    </header>

    <div class="flat-preview__info">
      <div class="flat-preview__data" v-if="soldStatusName !== statusName">
        <p class="flat-preview__label">{{ $t('singleFlat.area') }}:</p>
        <p class="flat-preview__value">
          {{ flat[flatProperties['area']] }}m<sup>2</sup>
        </p>
      </div>
      <div class="flat-preview__data" v-if="soldStatusName !== statusName">
        <p class="flat-preview__label">{{ $t('singleFlat.floor') }}:</p>
        <p class="flat-preview__value">
          {{ flat[flatProperties['floor']] }}
        </p>
      </div>
      <div class="flat-preview__data" v-if="soldStatusName !== statusName">
        <p class="flat-preview__label">{{ $t('singleFlat.rooms') }}:</p>
        <p class="flat-preview__value">
          {{ flat[flatProperties['rooms']] }}
        </p>
      </div>
      <div class="flat-preview__status" :class="status">
        {{ statusName }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  props: ['flat'],
  computed: {
    ...mapState({
      flatProperties: state => state.browser.flatProperties,
    }),
    status() {
      return this.$store.getters.GET_STATUS_CLASS(
        this.flat[this.flatProperties['status']]
      );
    },
    statusName() {
      return this.$store.getters.GET_STATUS_NAME(
        this.flat[this.flatProperties['status']]
      );
    },
    soldStatusName() {
      return this.$store.getters.GET_STATUS_NAME(
        this.flatProperties['status_sold']
      );
    },
  },
};
</script>

<style lang="scss" scoped>
sup {
  font-size: 10px;
  vertical-align: super;
}

.flat-preview__header {
  border-bottom: 1px solid $lightGray;
}

.flat-preview__number {
  font-weight: 400;
  font-size: 20px;
}

.flat-preview__status {
  font-weight: 400;
  font-size: 14px;
  &.available {
    color: $available;
  }

  &.reserved {
    color: $reserved;
  }

  &.sold {
    color: $sold;
  }
}

.flat-preview__info {
  margin-top: 4px;
}

.flat-preview__data {
  display: flex;
  align-items: center;
  margin: 4px auto;
}

.flat-preview__value {
  font-size: 12px;
  font-weight: 400;
}

.flat-preview__label {
  font-size: 12px;
  margin-right: 6px;
  color: rgba(#000000, 0.5);
}
</style>
